// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"695":"f6190258","787":"cda612ba"}[chunkId] + ".chunk.js";
};